import { render } from "./etapa.vue?vue&type=template&id=7fc58bd8&scoped=true"
import script from "./etapa.vue?vue&type=script&lang=js"
export * from "./etapa.vue?vue&type=script&lang=js"

import "./etapa.vue?vue&type=style&index=0&id=7fc58bd8&scoped=true&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc58bd8"]])

export default __exports__